module.exports = __webpack_public_path__ + "72311d7bd048e4ff68767e3a8ff1ac03.pdf";